import { isPresent } from './type-guards.js';

const checkForNum = (formatter)=>(value)=>{
        if (!isPresent(value) || typeof value === 'number' && isNaN(value)) {
            return undefined;
        }
        return formatter(value);
    }
;
const decimalFormatter = (v)=>v.toFixed(2)
;
const defaultFormatter = checkForNum((v)=>typeof v === 'number' ? `${v > 0 ? '+' : ''}${decimalFormatter(v)}` : v
);
const basicFormatter = checkForNum((v)=>v.toString()
);
const specificFormatters = {
    pupillaryDistance: basicFormatter,
    axis: basicFormatter,
    addition: basicFormatter
};
var _attributeName;
const getFormatter = (attributeName)=>(_attributeName = specificFormatters[attributeName]) !== null && _attributeName !== void 0 ? _attributeName : defaultFormatter
;
const formatPrescriptionValue = (name, value)=>getFormatter(name)(value)
;

export { formatPrescriptionValue, getFormatter };
//# sourceMappingURL=format-prescription-value.js.map
